import { GlobalOutlined } from '@ant-design/icons';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule.ts';
import { RequiredRule } from '../../../../rules/repository/required/Required.rule.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema.ts';
import { AsyncSelectConfigComponent } from './AsyncSelectConfigComponent.tsx';
import { AsyncSelectConfigSchema } from './AsyncSelectConfigSchema.ts';
import { AsyncSelectWidgetComponent } from './AsyncSelectWidgetComponent.tsx';
import { AsyncSelectWidgetPreview } from './AsyncSelectWidgetPreview.tsx';
import { createAsyncSelectFormSchema } from './createAsyncSelectFormSchema.ts';
import { getAsyncSelectOutputReferences } from './getAsyncSelectOutputReferences.ts';
import { getAsyncSelectWidgetReference } from './getAsyncSelectWidgetReference.ts';
import { type IAsyncSelectWidget } from './IAsyncSelectWidget.ts';
import { hydrateAsyncWidget } from './utils/hydrateAsyncWidget.ts';

export const AsyncSelectWidgetType: IWidgetType<IAsyncSelectWidget> = {
  type: WidgetType.AsyncSelect,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Advanced,
  name: 'Campo scelta da servizio',
  icon: <GlobalOutlined />,
  getReference: getAsyncSelectWidgetReference,
  getSiblingReferences: getAsyncSelectOutputReferences,
  hasValue: true,
  formComponent: AsyncSelectWidgetComponent,
  createFormSchema: createAsyncSelectFormSchema,
  previewComponent: AsyncSelectWidgetPreview,
  configValidator: AsyncSelectConfigSchema,
  configComponent: AsyncSelectConfigComponent,
  translationSchema: InputCommonTranslationSchema,
  rules: [RequiredRule, CustomWarningsRule],
  /**
   * Per le async select nell'hydrate ritorno, come valore
   * non il value del widget, ma la label mostrata all'utente,
   * così da poter valorizzare correttamente il pdf.
   */
  hydrate: hydrateAsyncWidget,
  aliases: ['async', 'servizio esterno'],
};
